import { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './BasePrimaryButton.module.css';

export interface BasePrimaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	isLoading?: boolean;
	icon?: ReactNode;
	fullWidth?: boolean;
}

export const BasePrimaryButton = ({
	children,
	className,
	isLoading = false,
	icon,
	fullWidth = false,
	disabled,
	...props
}: BasePrimaryButtonProps) => {
	const buttonClass = `
    ${styles.baseButton}
    ${fullWidth ? styles.fullWidth : ''}
    ${isLoading ? styles.loading : ''}
    ${className || ''}
  `.trim();

	return (
		<button className={buttonClass} disabled={disabled || isLoading} {...props}>
			{!isLoading && icon && <span className={styles.icon}>{icon}</span>}
			{isLoading && <span className={styles.spinner} />}
			<span>{children}</span>
		</button>
	);
};
